(function (angular) {
	angular.module('bizPartEngage').directive('bizSocialShare', bizSocialShareDirective);
	angular.module('bizPartEngage').service('bizSocialShareService', bizSocialShareService);

	bizSocialShareDirective.$inject = ["bizCore", "Socialshare"];
	bizSocialShareService.$inject = ["$http"];

	function bizSocialShareDirective(bizCoreProvider, Socialshare) {
		var directive = {
			restrict: "E",
			scope: {
				objectId: "@",
				objectType: "@",
				objectName: "@",
				uiStateName: "@",
				uiStateParams: "=",
				object: "=?",
				disabledProviders: "=?",
				likeActions: "@",
                likeActionObjectType: "@",
                useMenu: '=?'
			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl;
				}
				else {
					return bizCoreProvider.getView('core.directives.socialshare', "FrontEnd/Core/Directives/Views/SocialShare.html");
				}
			},
			bindToController: true,
			controller: bizSocialShareController,
			controllerAs: "vm"
		};

        bizSocialShareController.$inject = ["$rootScope", "$scope", "$state", "bizSocialShareService", "$mdToast"];

        function bizSocialShareController($rootScope, $scope, $state, bizSocialShareService, $mdToast) {
			var vm = this;

			vm.Providers = [{
				Name: "Twitter",
                Value: "twitter",
                Icon: "fab fa-twitter-square"
			}, {
				Name: "Facebook",
                Value: "facebook",
                Icon: "fab fa-facebook-square"
			}, {
				Name: "Linkedin",
                Value: "linkedin",
                Icon: "fab fa-linkedin"
			}, {
				Name: "Email",
                Value: "email",
                Icon: "fas fa-envelope-square"
			}, {
				Name: "Messenger",
                Value: "facebook-messenger",
                Icon: "fab fa-facebook-messenger",
				MobileOnly: true
			}, {
				Name: "Whatsapp",
                Value: "whatsapp",
                Icon: "fab fa-whatsapp-square",
				MobileOnly: true
			}
			];

			vm.Share = Share;
			vm.SetUrl = SetUrl;
			vm.GetShareUrl = GetShareUrl;
			vm.ShowShare = false;
            vm.PerformLikeAction = PerformLikeAction;
            vm.OnCopySuccess = OnCopySuccess;

            function OnCopySuccess(e) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Länk kopierad')                    
                );
            }

			function GetShareUrl() {
				return vm.Url + '?s=' + vm.TrackingId;
			}

			function SetUrl() {
				var state = vm.uiStateName || $state.current.name;
				var params = vm.uiStateParams || $state.params;

				vm.Url = $state.href(state, params, { absolute: true });
			}

			function Share(provider) {
				vm.Sharing = true;

				var share = {
					TrackingId: vm.TrackingId,
					Provider: provider.Value,
					ObjectId: vm.objectId,
					ObjectType: vm.objectType,
					Url: vm.Url
				}

				bizSocialShareService.AddSocialShare(share).then(AddSocialShareCallback);

				function AddSocialShareCallback() {
					vm.Sharing = false;
				}

				vm.TrackingId = Math.random().toString(36).substr(2, 10);
			}

			function PerformLikeAction(action) {
			    if (!action.LikeActionPerformedByUser) {
			        var LikeActionModel =
                        {
                            LikedUserId: vm.object.CreatedByUsr,
                            LikeKey: vm.likeActionObjectType,
                            ObjectId: vm.object.Id,
                            ActionId: action.Action.Id,
                            Comment: "Like action performed from social share directive."
			            }
			        bizSocialShareService.PerformLikeAction(LikeActionModel);
			        action.LikeActionPerformedByUser = true;
			        action.Count++;
			    }
			}

			vm.$onInit = function () {
				vm.TrackingId = Math.random().toString(36).substr(2, 10);
				vm.SetUrl();
				if (!vm.object && bizSocialShareService.loadedObject) {
				    console.log(bizSocialShareService.loadedObject);
				    vm.object = bizSocialShareService.loadedObject;
				    vm.likeActionObjectType = "BLOGENTRY";
				}

				if (vm.disabledProviders) {
					vm.Providers = vm.Providers.Where(function (provider) {
						return vm.disabledProviders.indexOf(provider.Value) == -1;
					});
				}
			}
		}

		return directive;
	}

	function bizSocialShareService($http) {

	    this.loadedObject = {};

	    var controllerPath = siteRootPath + "api/SocialShareUser/";
	    var likeActionPath = siteRootPath + "api/LikeAction/";

		this.AddSocialShare = function (share) {
			return $http.post(controllerPath + "AddSocialShare", share, {
				headers: {
					IgnoreLoader: true
				}
			});
		}

		this.AddSocialShareClick = function (click) {
			return $http.post(controllerPath + "AddSocialShareClick", click, {
				headers: {
					IgnoreLoader: true
				}
			});
		}

		this.PerformLikeAction = function (LikeActionModel) {
		    return $http.post(likeActionPath + "PerformLikeAction", LikeActionModel, {
		        headers: {
		            IgnoreLoader: true
		        }
		    });
		}
	}
})(window.angular);
